import React from "react";
import Index from "../../components/ContactUs";

const Contact = () => {
  return (
    <div>
      <Index />
    </div>
  );
};

export default Contact;
